// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3wEcE","text":"SelectPayment_text__1FQiD","title":"SelectPayment_title__15h8-","btn":"SelectPayment_btn__gappi"};